import { playersConfig } from './config';
import { PlayersResultTypes } from './types';
export class PlayersHelper {
    maxTimestamp;
    dnfValue;
    compareSkillBeforeTimestamp = false;
    constructor(maxTimestamp, dnfValue) {
        this.maxTimestamp = maxTimestamp;
        this.dnfValue = dnfValue;
    }
    sortingFunctionAscending = (a, b) => {
        if (a.finalResult === undefined || b.finalResult === undefined)
            return -1;
        if (!a.resultTimestamp)
            a.resultTimestamp = this.maxTimestamp;
        if (!b.resultTimestamp)
            b.resultTimestamp = this.maxTimestamp;
        if (!a.finalResultSecond)
            a.finalResultSecond = this.dnfValue;
        if (!b.finalResultSecond)
            b.finalResultSecond = this.dnfValue;
        if (!a.finalResultThird)
            a.finalResultThird = this.dnfValue;
        if (!b.finalResultThird)
            b.finalResultThird = this.dnfValue;
        const playableA = a.playable ? 1 : -1;
        const playableB = b.playable ? 1 : -1;
        return a.finalResult - b.finalResult ||
            a.finalResultSecond - b.finalResultSecond ||
            a.finalResultThird - b.finalResultThird ||
            (this.compareSkillBeforeTimestamp ? (b.attribute.total - a.attribute.total) : 0) ||
            a.resultTimestamp - b.resultTimestamp ||
            playableB - playableA;
    };
    sortingFunctionDescending = (a, b) => {
        if (a.finalResult === undefined || b.finalResult === undefined)
            return -1;
        if (!a.resultTimestamp)
            a.resultTimestamp = this.maxTimestamp;
        if (!b.resultTimestamp)
            b.resultTimestamp = this.maxTimestamp;
        if (!a.finalResultSecond)
            a.finalResultSecond = 0;
        if (!b.finalResultSecond)
            b.finalResultSecond = 0;
        if (!a.finalResultThird)
            a.finalResultThird = 0;
        if (!b.finalResultThird)
            b.finalResultThird = 0;
        const playableA = a.playable ? 1 : -1;
        const playableB = b.playable ? 1 : -1;
        if (playersConfig.resultType === PlayersResultTypes.meters) {
            if (a.resultsArrOrdered && b.resultsArrOrdered) {
                for (let i = 0; i < a.resultsArrOrdered.length; i++) {
                    if (a.resultsArrOrdered[i].main !== b.resultsArrOrdered[i].main) {
                        return b.resultsArrOrdered[i].main - a.resultsArrOrdered[i].main;
                    }
                    const aSecond = (a.resultsArrOrdered[i].second ?? 0);
                    const bSecond = (b.resultsArrOrdered[i].second ?? 0);
                    if (aSecond !== bSecond) {
                        return bSecond - aSecond;
                    }
                    const aThird = (a.resultsArrOrdered[i].second ?? 0);
                    const bThird = (b.resultsArrOrdered[i].second ?? 0);
                    if (aThird !== bThird) {
                        return bThird - aThird;
                    }
                }
                return (this.compareSkillBeforeTimestamp ? (b.attribute.total - a.attribute.total) : 0) ||
                    a.resultTimestamp - b.resultTimestamp ||
                    playableB - playableA;
            }
        }
        return b.finalResult - a.finalResult ||
            b.finalResultSecond - a.finalResultSecond ||
            b.finalResultThird - a.finalResultThird ||
            (this.compareSkillBeforeTimestamp ? (b.attribute.total - a.attribute.total) : 0) ||
            a.resultTimestamp - b.resultTimestamp ||
            playableB - playableA;
    };
    sortingFunctionAttribute = (a, b) => {
        if (a.attribute.total === undefined || b.attribute.total === undefined)
            return -1;
        return b.attribute.total - a.attribute.total;
    };
}
//# sourceMappingURL=PlayersHelper.js.map